import PageMeta from 'components/PageMeta'
import { withApollo } from 'components/withApollo'
import { NextPage } from 'next'
import PageError from 'components/pages/PageError'
import LoadingPage from 'components/pages/LoadingPage'
import Checkout from 'components/pages/CartPage/Checkout'
import ItemRecommendations from 'components/pages/CartPage/ItemRecommendations'
import EmptyCart from 'components/pages/CartPage/EmptyCart'

import { useCartPage } from './types/query'
import TruckInfo from './TruckInfo'
import CartItems from './CartItems'

const CartPage = () => {
  const { data, loading, error, refetch } = useCartPage()

  const cart = data?.currentCart

  const meta = <PageMeta canonicalPath="/" title="Best Food Trucks | Cart" />

  if (error) return <PageError meta={meta}>{error.message}</PageError>
  if (loading) return <LoadingPage meta={meta} />

  const isEmpty = !cart?.location || cart.items.length === 0

  return (
    <div>
      {meta}
      <div className="min-h-screen md:max-w-screen-sm lg:max-w-screen-xl mx-auto py-4 px-4">
        <div className="lg:mt-4">
          <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Review Order
          </h1>
          {isEmpty && <EmptyCart locationUrl={cart?.location?.customerUrl} />}
          {!isEmpty && (
            <div className="pt-4 lg:grid grid-cols-9 gap-12">
              <div className="col-span-5">
                <TruckInfo cart={cart!} />
                <CartItems cart={cart!} refetch={refetch} />
                <ItemRecommendations cartUuid={cart!.uuid!} />
              </div>
              <div className="col-span-4">
                <Checkout cart={cart!} cartRefetch={refetch} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const CartPageWithApollo = withApollo({ ssr: true })(CartPage as NextPage)
export default CartPageWithApollo
